import axios from '../../../../utills/axiosConfig';

export const fetchProductTypes = async () => {
  const res = await axios.get('/product-type');
  return res.data;
};

export const addProductType = async (productType) => {
  try {
    const res = await axios.post('/product-type', productType);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateProductType = async (id, productType) => {
  const res = await axios.put(`/product-type/${id}`, productType);
  return res.data;
};

export const deleteProductType = async (id) => {
  const res = await axios.delete(`/product-type/${id}`);
  return res.data;
};

export const importProductTypeCSV = async (formData) => {
  const { data } = await axios.post('/product-type/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 